//	Hacking SVG sprites setup
//	Reference: https://github.com/kisenka/svg-sprite-loader/issues/202

const sprites = require.context('./images/svg', true , /\.svg/);

//It loop all the the svgs and make them a specific element
sprites.keys().map((moduleName) => sprites(moduleName).default);
